




import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { FormSelect } from "../../parts";

@Component({
    components: {
        FormSelect
    }
})
export default class FromJobToolzMultipleChoice extends Vue {
    @Prop({ default: undefined }) readonly value!: boolean | undefined;

    @Prop() placeholder?: string;

    @Prop() name?: string;

    @Prop({ default: false }) readonly required!: boolean;

    @Prop() rules?: string | object;

    options = ["Ja", "Neen"];

    localValue: string = "";

    @Watch("value", { immediate: true })
    handleValueChange(value: boolean | undefined) {
        if (value === undefined) {
            this.localValue = "";
            return;
        }

        this.localValue = value === true ? "Ja" : "Neen";
    }

    @Watch("localValue")
    handleLocalValueChange(value: string) {
        this.$emit("input", value === "Ja" ? true : false);
    }
}
